var CorsClient = require('./cors'),
  log = require('./logger').getLoggerInstance('Base.S3Writer'),
  logPath = '/log',
  s3WriterUrl,
  clientMutator,
  clientApplication,
  isInitialized = false,
  requestQueue = [],
  batchTimeoutId = 0,
  batchTimeout = 5000, // 5 seconds
  windowInstance;

var privateMethods = {
  startTimer: function () {
    batchTimeoutId = setTimeout(function () {
      privateMethods.sendQueuedRequests();
    }, batchTimeout);
  },
  stopTimer: function () {
    if (batchTimeoutId > 0) {
      clearTimeout(batchTimeoutId);
    }
    batchTimeoutId = 0;
  },
  sendQueuedRequests: function () {
    var client,
      s3Request = {
        'mutator': clientMutator,
        'application': clientApplication,
        'data': requestQueue.splice(0)
      };

    privateMethods.stopTimer();
    if (s3Request.data.length > 0) {
      client = privateMethods.createCorsClientWithoutS3WriterIntegration(s3WriterUrl);

      client.post(logPath, s3Request)
        .then(function () {
          log.debug('s3 client post successful');
        }).catch(function (error) {
          log.error('s3 client post failed: ' + JSON.stringify(error));
        }).finally(function () {
          privateMethods.startTimer();
        });
    } else {
      privateMethods.startTimer();
    }
  },
  createCorsClientWithoutS3WriterIntegration: function (url) {
    return new CorsClient(url, true, null, false, 0);
  },
  createRequest: function (clientId, action, runTime, wasSuccessful, millisFromLoad, redirectCount, location) {
    var request = {
      'clientId': clientId,
      'action': action,
      'runTime': runTime,
      'wasSuccessful': wasSuccessful,
      'location': location
    }
    if (millisFromLoad) {
      request.millisFromLoad = millisFromLoad;
    }
    if (redirectCount) {
      request.redirectCount = redirectCount;
    }
    return request;
  }
},
  publicMethods = {
    /**
     * Initializes the s3 client client
     * @param {string} url - the s3 client url to use
     * @param {string} mutator - the supported mutator to use when formatting the payload
     * @param {string} application - the application requesting the data capture to the s3 client
     */
    initialize: function (window, url, mutator, application) {
      windowInstance = window;
      clientMutator = mutator;
      clientApplication = application;
      s3WriterUrl = url;

      isInitialized = true;
    },
    /**
     * Sends the s3 client log data
     * @param {string} clientId - a unique id that represents the client sending the data
     * @param {string} action - the event data for the capture
     * @param {number} runTime - the elapsed time in milliseconds for the event being captured
     * @param {boolean} wasSuccessful - flag to indicate if the result of the attempted action was successful 
     * @param {number} millisFromLoad - 	The amount of time elapsed since page load when this event occurred
     * @param {number} redirectCount - if applicable, the number of redirects involved in the current timing process 
     */
    capture: function (clientId, action, runTime, wasSuccessful, millisFromLoad, redirectCount) {
      if (!isInitialized) {
        log.error('s3 client not initialized');
        return;
      }

      requestQueue.push(privateMethods.createRequest(clientId, action, runTime, wasSuccessful,
        millisFromLoad, redirectCount, windowInstance.location.pathname));
    },
    /**
     * Sends all the requests to the S3 writer
     */
    flushAll: function () {
      privateMethods.sendQueuedRequests();
    },
    /**
     * Gets the number of items in the request queue
     */
    getRequestQueueLength: function () {
      return requestQueue.length;
    }
  };

module.exports = publicMethods;


//////////////////
// WEBPACK FOOTER
// ./libraries/s3Writer.js
// module id = 60
// module chunks = 0 5 20